import { Link } from 'react-router-dom'

const ParaEmpresasNavbar = () => (
  <header
    className="fixed left-0 right-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-md"
    style={{ top: 'var(--maintenance-banner-height, 0px)' }}
  >
    <div className="container flex items-center justify-between h-16">
      <Link to="/landing" className="flex items-center gap-1">
        <span className="text-xl font-bold text-gradient">AI</span>
        <span className="text-xl font-bold text-foreground">Sym</span>
      </Link>
      <div className="flex items-center gap-3">
        <Link to="/auth" className="btn-primary text-sm py-2 px-4">
          Já tenho uma conta
        </Link>
      </div>
    </div>
  </header>
)

export default ParaEmpresasNavbar
